module.exports = __webpack_public_path__ + "static/img/contract2.d6eac65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract2.png
// module id = rQlg
// module chunks = 1